import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { MACROECONOMICS_TAB, VIEW_BY } from '../constant'

const slice = createSlice({
  name: 'industryOverview/macroeconomics',
  initialState: {
    activeTab: MACROECONOMICS_TAB.GDP.key,
    viewBy: VIEW_BY.CHART,
  },
  reducers: {
    changeActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    changeViewBy: (state, action) => {
      state.viewBy = action.payload
    },
  },
})

export const selectActiveTab = (state) => state[slice.name].activeTab
export const selectViewBy = (state) => state[slice.name].viewBy

export const { changeData, changeActiveTab, changeViewBy } = slice.actions

register(slice.name, slice.reducer)
